import { render, staticRenderFns } from "./exam_paired_association.vue?vue&type=template&id=ddada198&scoped=true&"
import script from "./exam_paired_association.vue?vue&type=script&lang=js&"
export * from "./exam_paired_association.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddada198",
  null
  
)

export default component.exports